import React from 'react';
import { Navbar, Container, Nav, Button, Badge } from 'react-bootstrap';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { isAdmin, isClinicHead, getUsername } from '../auth';

const AppNavbar: React.FC = () => {
    const navigate = useNavigate();
    const admin = isAdmin();
    const clinicHead = isClinicHead();
    const username = getUsername();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    const navLinkClass = ({ isActive }: { isActive: boolean }) =>
        `nav-link mx-2 fw-medium ${isActive ? 'text-primary' : 'text-secondary'}`;

    return (
        <Navbar expand="lg" className="shadow-sm mb-0 sticky-top brand-navbar">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2 p-0">
                    <img src="/logo_blue.png" alt="TeriAI" height={32} />
                    <span className="d-none d-md-inline text-muted small fw-normal ms-1">Админ</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-nav" />
                <Navbar.Collapse id="main-nav">
                    <Nav className="me-auto ms-3">
                        {admin && (
                            <>
                                <NavLink to="/" end className={navLinkClass}><i className="bi bi-bar-chart-line me-1"></i>Дашборд</NavLink>
                                <NavLink to="/images" className={navLinkClass}><i className="bi bi-images me-1"></i>Снимки</NavLink>
                                <NavLink to="/users" className={navLinkClass}><i className="bi bi-people me-1"></i>Пользователи</NavLink>
                                <NavLink to="/accounts" className={navLinkClass}><i className="bi bi-graph-up-arrow me-1"></i>Аккаунты</NavLink>
                                <NavLink to="/prompts" className={navLinkClass}><i className="bi bi-chat-square-text me-1"></i>Промпты</NavLink>
                            </>
                        )}
                        {(admin || clinicHead) && (
                            <NavLink to="/clinics" className={navLinkClass}><i className="bi bi-hospital me-1"></i>Клиники</NavLink>
                        )}
                    </Nav>
                    <Nav className="align-items-center gap-2">
                        {admin && <Badge bg="primary" pill className="px-3 py-2">Администратор</Badge>}
                        {clinicHead && !admin && <Badge bg="info" pill className="px-3 py-2">Главный врач</Badge>}
                        {username && (
                            <span className="text-secondary small">
                                <i className="bi bi-person-circle me-1"></i>{username}
                            </span>
                        )}
                        <Button variant="outline-secondary" size="sm" className="px-3 rounded-pill" onClick={handleLogout}>
                            <i className="bi bi-box-arrow-right me-1"></i>Выйти
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;
